import { sendSMSToCaregiver } from "api/messages";
import { useGlobalToast } from "components/GlobalToastProvider";
import { useMutation } from "react-query";
/**
 * Custom hook to send an SMS message to a caregiver and show a toast on success.
 *
 * @param {Object} [options={}] - Optional configuration for the mutation.
 * @param {Function} [options.onSuccess] - Callback fired after a successful message send.
 *
 */
export const useSendSMSToCaregiver = (options = {}) => {
  const { onSuccess = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();
  const { mutate, mutateAsync, ...rest } = useMutation(
    (messageData) => sendSMSToCaregiver(messageData),
    {
      onSuccess: () => {
        showToast({
          message: "Message sent!",
        });
        onSuccess();
      },
      onError: () => {
        showToast({ message: "Error sending message." });
      },
      ...otherOptions,
    }
  );
  return {
    sendSMSMutation: mutate,
    sendSMSMutationAsync: mutateAsync,
    ...rest,
  };
};
